export default "__VITE_ASSET__Cbi9LH7s__"